import { createCustomIcon } from './utils/createCustomIcon';

const AdminTeceoIcon = createCustomIcon({
  displayName: 'AdminTeceoIcon',
  children: (
    <>
      <path d="M12.9521 12.0476L21.9998 12.0476" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M19.2858 8.6548C18.5103 5.8274 15.3383 3 11.4747 3C6.79426 3 3 7.05079 3 12.0477C3 17.0446 6.79426 21.0954 11.4747 21.0954C15.3383 21.0954 18.3811 18.3811 19.2858 15.4406"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </>
  ),
});

export default AdminTeceoIcon;
